import Vue from "vue";

const store = () => window.$store;

async function crypto(state, payload) {
  const methods = {
    address: async () => {
      // payload.data = {chain, passhash, key}
      return store().dispatch("api", {
        address: store().state.cloudurl + "getaddress",
        verb: "post",
        data: payload.data,
      });
    },
    asset: async () => {},
    mint: async () => {
      let tx = payload.data.tx,
        key = payload.data.key,
        inputs = payload.data.inputs;
      let metadata = {};
      let mint = function (tx) {
        console.log({ minting: tx });
        const [t, f] = [true, false];
        store().commit("point", { header: "minting", text: payload.data, sticky: t });
        let developing = f;
        if (developing) {
          return { tx };
        }
        return store()
          .dispatch("api", {
            address: store().state.cloudurl + "minttokens",
            verb: "post",
            data: tx,
          })
          .then((x) => {
            console.log({ x });
            return x;
          })
          .catch((e) => console.log({ e }));
      };

      tx.address = inputs.selectaddress[key].address;
      tx.chain = inputs.selectaddress[key].chain;
      tx.verification = key;
      tx.passhash = inputs.newtx[key].passhash;
      tx.submit = "True";
      store().commit("point", {
        header: "Minting",
        text: `Minting ${JSON.stringify(tx)} from ${
          inputs.selectaddress[key].address
        }`,
        type: "update",
        sticky: true,
      });
      tx.inputs = [];
      console.log({ minting_tx: tx });
      // TODO encrypt with cloud public key
      if (tx.meta.fileids) {
        store().commit("point", { header: "Minting", text: "Processing Files" });
        metadata.files = tx.meta.fileids.map(
          (x) => store().state.user[store().state.auth.uid].files[x]
        );
        metadata.files = metadata.files.map((x) => {
          return {
            mediaType: x.type,
            name: x.name,
            src: "ipfs://" + x.ipfs,
            xmbl: x.token[1],
            filehash: x.token[0],
            size: x.size.toString(),
          };
        });
        if (metadata.files.length == tx.meta.fileids.length) {
          tx.meta.files = metadata.files;
          delete tx.meta.fileids;
          store().commit("point", {
            header: `Minting`,
            text: "with required file metadata.",
          });
          return mint(tx);
        }
      } else return mint(tx);
    },
    tx: async () => {
      let tx = payload.data.tx,
        key = payload.data.key,
        inputs = payload.data.inputs;
      console.log({ tx });
      tx.address = inputs.selectaddress[key].address;
      tx.chain = inputs.selectaddress[key].chain;
      tx.verification = key;
      "point",
        {
          header: "Creating Transaction",
          text: `Sending ${JSON.stringify(tx.outputs)} from ${
            inputs.selectaddress[key].address
          }`,
          type: "update",
        };
      tx.inputs = [];
      // TODO encrypt with cloud public key
      return store()
        .dispatch("api", {
          address: store().state.cloudurl + "createtx",
          verb: "post",
          data: tx,
        })
        .then((x) => {
          if (x.data.traceback) {
            store().commit("point", {
              header: "Transaction Failed",
              text: JSON.stringify(x.data.traceback),
              sticky: true,
              type: "warn",
            });
          } else {
            store().commit("point", {
              header: "Transaction Created",
              text: x.data,
            });
          }
          if (!tx.submit) {
            const txid = x.data[0];
            let savetx = {
              cbor: x.data[1],
              chain: tx.chain,
              outputs: tx.outputs,
            };
            let userkeys = store().state.users[store().state.auth.uid].keys;
            // this.$set(this.disabled, key, false);
            userkeys[key].txs = userkeys[key].txs || {};
            Vue.set(userkeys[key].txs, txid, savetx);
            store().dispatch("update", { type: "keys", keys: userkeys });
            return x.data[1];
          } else {
            return x.data;
          }
        })
        .catch((e) => e);
    },
    fee: async () => {
      // payload.data = {tx}
      const size = new TextEncoder().encode(
        JSON.stringify(payload.data.tx)
      ).length;
      return Math.round(88.888 * size);
    },
  };
  return await methods[payload.type](payload.data).then((x) => x);
}

export { crypto };

